import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: { spacing: '1' },
  link: {
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'var(--local-gradient-blue, linear-gradient(180deg, #3B63C3 0%, #2F4F9C 100%))',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.20) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    borderRadius: 'lg',
    display: 'flex',
    flex: ['1', null, null, '0 1 auto'],
    fontSize: '2xs',
    fontWeight: 'bold',
    pos: 'relative',
    px: '2.5',
    py: ['2.5', null, null, '5px'],
    textAlign: 'center',
    textTransform: 'uppercase',
    transitionDuration: 'normal',
    transitionProperty: 'common',
    zIndex: '1',
    color: 'white',
    sx: {
      svg: {
        color: 'delta.500',
      },
      '&.active': {
        color: 'beta.900',
        bg: 'unset',
        bgGradient: 'linear(to-b, blackAlpha.500, blackAlpha.500)',
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.20) inset',
        svg: {
          color: 'beta.900',
        },
      },
    },
  },
};
